import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface UserProperties {
    id?: number;
    userId?: string;
    userPropertyKey: string;
    userPropertyValue: string;
    type: string;
    propertyGroup?: string;
    createdAt?: string;
    updatedAt?: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserPropertiesService {

    private baseUrl = '/api/sipo/userproperties';

    constructor(private http: HttpClient) { }

    getAll(): Observable<UserProperties[]> {
        return this.http.get<UserProperties[]>(this.baseUrl);
    }

    getAllByGroup(group: string): Observable<UserProperties[]> {
        return this.http.get<UserProperties[]>(`${this.baseUrl}/groups/${group}`);
    }

    getByKey(key: string): Observable<UserProperties> {
        return this.http.get<UserProperties>(`${this.baseUrl}/${key}`);
    }

    createBulk(properties: UserProperties[]): Observable<UserProperties[]> {
        return this.http.post<UserProperties[]>(`${this.baseUrl}/bulk`, properties);
    }

    create(property: UserProperties): Observable<UserProperties> {
        return this.http.post<UserProperties>(this.baseUrl, property);
    }

    update(property: UserProperties): Observable<UserProperties> {
        return this.http.put<UserProperties>(this.baseUrl, property);
    }

    delete(key: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${key}`);
    }
}
